
@if (attendeeQuestionsContext$ | async; as attendeeQuestions) {
	<tabset justified="true" class="sidebar-tabset sidebar-tabset-scrollable">
		<tab #myQuestionsTab="tab" [heading]="'Event_MyQuestionsAndAnswersWithCount' | translate : { '0': attendeeQuestions.questions?.length ?? 0 }" tabOrder="1" role="menuitem">
			
			@if (attendeeQuestions.questions.length > 0) {
				<vb-webcast-questions-list class="margin-top-5" [webcast]="webcast" [questions]="attendeeQuestions.questions" [questionContext]="QuestionContext.myQuestions">
				</vb-webcast-questions-list>
			} @else {
				<div class="noQuestionAsked">{{ 'Event_QA_NoAsks' | translate }}</div>
			}

		</tab>
		<tab [heading]="'Event_GroupQuestionsAndAnswersWithCount' | translate: { '0': attendeeQuestions.publicQuestions?.length ?? 0 }" tabOrder="2" role="menuitem">

			@if (attendeeQuestions.publicQuestions.length > 0) {
				<vb-webcast-questions-list class="margin-top-5" [webcast]="webcast" [questions]="attendeeQuestions.publicQuestions" [questionContext]="QuestionContext.groupQuestions">
				</vb-webcast-questions-list>
			} @else {
				<div class="noQuestionAsked">{{ 'Event_QA_NoAsksGroups' | translate }}</div>
			}
		</tab>
	</tabset>
	@if (myQuestionsTab?.active) {
		<vb-webcast-ask-question class="width-full margin-bottom-10" [context]="context" [webcast]="webcast" (questionAsked)="onQuestionAsked($event.question)">
		</vb-webcast-ask-question>
	}
}

